import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'app/helpers/routing';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { TextButton } from '@bibliocommons/base-buttons';

import { Pill } from 'app/components/shared/Pill';
import Heading from 'app/components/shared/Heading';
import './LocationsActiveFilters.scss';

const FILTERS = ['facilities', 'near', 'open'];

export default function LocationsActiveFilters({ activeFilters }) {
  const router = useRouter();
  const filtersActive = !!activeFilters.size && FILTERS.some(filter => activeFilters.get(filter));
  const facilities = activeFilters.get('facilities');

  function handleFilterDismiss(filter, value) {
    const locationsQuery = router.query;

    let facilitiesFilter = locationsQuery.facilities;
    switch (filter) {
      case 'facilities': {
        facilitiesFilter = locationsQuery.facilities
          .split(',')
          .filter(id => id !== value)
          .join(',');
        break;
      }
      case 'near': {
        delete locationsQuery.near;
        break;
      }
      default:
        delete locationsQuery[filter];
    }

    locationsQuery.facilities = facilitiesFilter;
    router.push({
      query: locationsQuery
    });
  }

  function renderOpenNowPill() {
    if (!activeFilters.get('open')) return null;
    return (
      <Pill key="open-now-pill" handleDismiss={() => handleFilterDismiss('open')}>
        <FormattedMessage id="open_now" />
      </Pill>
    );
  }

  function renderNearbyPill() {
    if (!activeFilters.get('near')) {
      return null;
    }
    return (
      <Pill key="nearby-pill" handleDismiss={() => handleFilterDismiss('near')}>
        <FormattedMessage id="near_my_location" />
      </Pill>
    );
  }

  return filtersActive ? (
    <div className="cp-location-filters">
      <ScreenReaderMessage>
        <Heading tagName="h2">
          <FormattedMessage id="location_active_filters" />
        </Heading>
      </ScreenReaderMessage>
      {renderOpenNowPill()}
      {renderNearbyPill()}
      {facilities?.map(filter => (
        <Pill
          key={`pill-${filter.get('value')}`}
          handleDismiss={() => handleFilterDismiss('facilities', filter.get('value'))}
        >
          {filter.get('label')}
        </Pill>
      ))}
      <TextButton handleClick={() => router.replace({ query: null })} dataKey="clear-filters-button">
        <FormattedMessage id="clear_filters" />
      </TextButton>
    </div>
  ) : null;
}

LocationsActiveFilters.propTypes = {
  activeFilters: ImmutablePropTypes.map.isRequired
};
